<template>

  <!-- 产品分类 -->
  <div style="background:#f9f9f9;padding-bottom:50px;">
    
  <div class="goods_cate" style="width: 1240px; margin: 0 auto;">

      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item
          v-for="(item, index) in breadData"
          :key="index"
          :to="item.path"
          ><a>{{ item.name }}</a></el-breadcrumb-item
        >
      </el-breadcrumb>

    <div   class="nav">
	<div  class="navCon wrapper_1200 acea-row row-between-wrapper">
		<div   class="list  row-middle" style="
    
    ">
    <el-tabs v-model="topCateId" >
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane  :key="cindex" v-for="(cvalue,cindex) in cateTree" :label="cvalue.name" :name="cvalue.id+''"></el-tab-pane> 
    </el-tabs>

  
			<!-- <div  style="float:left"  :class="topCateId==0?'font-color item':'item'"  @click="changeTopChange(0)">
				全部
			</div>
			<div   style="float:left" :class="topCateId==cvalue.id?'font-color item':'item'"  @click="changeTopChange(cvalue,cindex)"   :key="cindex" v-for="(cvalue,cindex) in cateTree">
				{{cvalue.name}}
			</div> -->
		</div>

	</div>
</div>

    <div class="wrapper wrapper_1200">


      <!-- <div class="goods-cate-box">
        <div
          :class="
            cate_index == 0 ? 'goods-cate goods-cate-active' : 'goods-cate'
          "
          @click="onCateChange(0, -1)"
        >
          全部
        </div>
        <div
          :class="
            cate_index == i + 1 ? 'goods-cate goods-cate-active' : 'goods-cate'
          "
          v-for="(item, i) in cateList"
          @click="onCateChange(item.id, i)"
          :key="i"
        >
          {{ item.name }}
        </div>
      </div> -->



      
      <div class="acea-row"  v-if="cateList.length>0" >
        <div class="name">分类：</div>
        <div class="listCon acea-row row-between">
          <div class="list acea-row row-middle" :class="sortNav ? '' : 'on'">

            <div
              class="item"
              :class="subCateId == topCateId ? 'font-color' : ''" 
              :key="-1"
              @click="onCateChange(topCateId, 0)"
            >
              全部
            </div>

            <div
              class="item"
              :class="subCateId == (item.id) ? 'font-color' : ''"
              v-for="(item, index) in cateList"
              :key="index"
              @click="onCateChange(item.id, index)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- <div
            class="iconfont"
            :class="sortNav ? 'icon-xiangshang' : 'icon-xiangxia'"
            @click="sortTap"
          ></div> -->
        </div>
      </div>

      <div class="sort acea-row">
        <div class="name">排序：</div>
        <div class="acea-row row-middle">
          <div
            class="item"
            :class="'font-color'"
            @click="defaults"
          >
            默认 
          </div>
          <div
            class="item"
            :class="iSdefaults === 1 ? 'font-color' : ''"
            @click="priceSort('desc')"
            v-if="priceOrder === 'asc'"
          >
            价格
            <span class="iconfont icon-jiageshaixuanshang"></span> 
          </div>
          <div
            class="item"
            :class="iSdefaults === 1 ? 'font-color' : ''"
            @click="priceSort('asc')"
            v-else-if="priceOrder === ''"
          >
            价格
            <span class="iconfont icon-jiageshaixuan"></span>
          </div>
          <div
            class="item"
            :class="iSdefaults === 1 ? 'font-color' : ''"
            @click="priceSort('')"
            v-else
          >
            价格
            <span class="iconfont icon-jiageshaixuanxia"></span>  
          </div>
          <div
            class="item"
            :class="''"
            @click="timeNews"
          >
            上架时间
            <span
              class="iconfont icon-shangjiashijian"
              :class="''"
            ></span>
          </div>
        </div>
      </div>


    </div>
  </div>

  <div class="cmsdetail">
    <div class="container_wrap">
      <el-alert
        v-if="this.noticeData.length"
        :title="this.noticeData[0].title"
        type="warning"
        :description="this.noticeData[0].desc"
        style="margin-top:10px"
      >
      </el-alert>
      <div class="goods-cate-box" v-if="false">
        <div
          :class="
            cate_index == 0 ? 'goods-cate goods-cate-active' : 'goods-cate'
          "
          @click="onCateChange(0, -1)"
        >
          全部
        </div>
        <div
          :class="
            cate_index == i + 1 ? 'goods-cate goods-cate-active' : 'goods-cate'
          "
          v-for="(item, i) in cateList"
          @click="onCateChange(item.id, i)"
          :key="i"
        >
          {{ item.name }}
        </div>
      </div>

      
      <div class="goods-main-box">
        <div
          class="goods-items"
          v-for="(item, x) in list"
          :key="x"
          @click="onGoodsDetail(item.id)"
        >
          <img v-lazy="item.pic_url" alt srcset />
          <div class="p1">
            <span class="goods-items-span1">
              <span style="font-size: 12px">¥</span>
              {{ item.price_range[0] }}
              <span class="span1-span" style="text-decoration:line-through ;color:#999;margin-left:10px">¥{{ item.orig_price }}</span>
            </span>
            <span class="goods-items-span2"
              >已售出{{ item.sold_count + item.sold_show_count }}</span
            >
          </div>
          <div class="goods-title">{{ item.title }}</div>
          <!-- <div class="goods-buys">
            <span class="buy-btn">立即购买</span>
          </div> -->
          <div class="p1">
            <span class="goods-items-span2">
               {{ item.sold_count + item.sold_show_count }}人付款购买
            </span>
            <span class="goods-items-span2"
              > </span
            >
          </div>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="row.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
      :show-close="false"
      :close-on-click-modal='false'
      :close-on-press-escape="false"
    >
      <span>萌星商城产品即将上新，敬请期待！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$router.push({path:'indexpc'})"
          >返回首页</el-button
        >
      </span>
    </el-dialog> -->
  </div>
  </div>
</template>
<script>
export default {
  name: "GoodsList",
  data() {
    return {
      noticeData:[],
      // centerDialogVisible:true,
      breadData: [
        { name: "首页", path: "/indexpc" },
        { name: "采购商城", path: "/goodslist" },
      ], //面包屑的内容
      cateList: [],
      cateTree: [],
      list: [],
      cate_index: 0,
      priceOrder: "",
      sortNav:'',
      iSdefaults: 0,
      topCateId :0,
      subCateId :0,
      params: {
        keywords: this.$route.query.keywords,
        cate_id: "",
        p: 1,
        step: 10,
      },
      row: {},
    };
  },
  mounted() {
    this.topCateId =  this.$route.query.cate_id||0;
    if(this.topCateId){
      this.params.cate_id = this.topCateId;
      setTimeout(() =>{ 
         let thiscat = this.cateTree.filter(item => {
          return item.id == this.topCateId
        })
        if(typeof thiscat[0]['children'] == 'undefined'){
        this.cateList = []
        }else{
        this.cateList = thiscat[0]['children']
        }
      },300)
    }
    this.subCateId =  this.$route.query.sub_cate_id||0;
    if(this.subCateId){
      this.params.cate_id = this.subCateId;
    }
    this.getGoodsList(); 
  },
  watch:{
    topCateId(value){
      this.changeTopChange({
        id:value
      })
    }
  },
  methods: {
    changeTopChange(value){
      if(value.id==0){
        this.cateList = [];
        this.params.cate_id = 0
        this.params.p = 1;
        this.list = [];
        this.topCateId = 0;
        this.subCateId = 0;
        this.getGoodsList();  
      }else{
        let thiscat = this.cateTree.filter(item => {
          return item.id == value.id
        })

        if(typeof thiscat[0]['children'] == 'undefined'){
        this.cateList = []
        }else{
        this.cateList = thiscat[0]['children']
        }
        this.topCateId = value.id;
        this.params.cate_id = value.id;
        this.subCateId = value.id;
        this.params.p = 1;
        this.list = [];
        this.getGoodsList(); 
      }
    }, 
    onGoodsDetail(id) {
      this.$router.push({ path: "/goodsdetail", query: { id: id } });
    },
    onCateChange(val, i) { 
      this.params.cate_id = val;
      this.subCateId = val;
      this.params.p = 1;
      this.list = [];
      this.getGoodsList();
    },
    getGoodsList() {
      let that = this;
      that.$api.get(
        "/api/goods/goodsList",
        that.params,
        (res) => {
          that.row = res.data;
          that.list = res.data.list;
          // that.cateList = res.data.cate_list;
          if(that.params.p==1){
          that.cateTree = res.data.cate_tree;
          }
        },
        (r) => {}
      );
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.params.p = val;
      this.getGoodsList();
      window.scrollTo(0, 0);
    },

    defaults() {
      this.iSdefaults = 0;
      this.productslist = [];
      this.pullRefreshss = true;
      this.page = 1;
      this.news = 0;
      this.priceOrder = "";
      this.getGoodsList();
    },
    priceSort(sort) {
      this.iSdefaults = 1;
      this.productslist = [];
      this.pullRefreshss = true;
      this.page = 1;
      this.news = 0;
      this.priceOrder = sort;
      this.getGoodsList();
    },
    timeNews() {
      this.iSdefaults = 2;
      this.productslist = [];
      this.pullRefreshss = true;
      this.priceOrder = "";
      this.page = 1;
      this.news = !this.news === true ? 1 : 0;
      this.getGoodsList();
    },
    //tab点击事件
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.cmsdetail {
  width: 100%;
  background: #f9f9f9;
  height: 100%;
  overflow: hidden;
}
.pagination-box {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}
.goods-main-box {
  width: 1200px;
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  min-height: 600px;
  cursor: pointer;
  .goods-items:hover{
      box-shadow:0 3px 20px rgba(0, 0, 0, 0.1)
    }
  .goods-items {
    width: 227px;
    height: 350px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.03);
    margin-bottom: 20px;
    margin-right: 15px;
    overflow: hidden;
    &:hover {
      img {
        transform: scale(1.05);
      }
    }
    
    .goods-title {
      width: 207px;
      padding: 0 10px;
      height: 40px;
      font-size: 14px;
      font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
        "\5FAE\8F6F\96C5\9ED1";
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }
    .goods-buys {
      width: 217px;
      display: flex;
      flex-direction: row-reverse;
      padding: 0 5px;
      .buy-btn {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
        width: 100px;
        background: #1981ff;
        border-radius: 20px;
        &:hover {
          cursor: pointer;
          font-weight: bold;
          opacity: 0.9;
        }
      }
    }
    img {
      width: 227px;
      height: 227px;
      transition: all 0.3s;
      // &:hover {
      //   transform: scale(1.04);
      // }
    }
    .p1 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      width: 217px;
      padding: 0 10px;
      margin: 10px 0;
      .goods-items-span1 {
        height: 26px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: red;
        line-height: 26px;
        display: flex;
        align-items: flex-end;
        .span1-span {
          height: 16px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: 1981ff;
          line-height: 16px;
        }
      }
      .goods-items-span2 {
        height: 16px;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #666666;
        line-height: 16px;
      }
    }
  }
  .goods-items:nth-of-type(5n) {
    margin-right: 0;
  }
}
.goods-cate-box {
  width: 1160px;
  // height: 81px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  .goods-cate {
    margin-right: 20px;
    height: 33px;
    font-size: 16px;

    font-weight: 400;
    color: #666666;
    line-height: 33px;
    cursor: pointer;
    &:hover {
      font-weight: bold;
    }
  }
  .goods-cate-active {
    color: #d22c46;
  }
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
}
.elbreadcrumb {
  width: 1200px;
  height: 41px;
  line-height: 41px;
  background: rgba(255, 255, 255, 0.96);
  margin-top: 43px;
}
.breadcrumb {
  margin-top: 21px; 
  padding: 16px 0 16px 0;
}

.goods_cate {
  font-size: 14px;
  margin-top: 2px;
  .noGoods {
    text-align: center;
    .pictrue {
      width: 274px;
      height: 174px;
      margin: 130px auto 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-size: 14px;
      color: #969696;
      margin-top: 20px;
      margin-bottom: 290px;
    }
  }
  .nav {
    width: 100%;
    height: 50px;
    cursor: pointer;
    margin-bottom: 10px;
    .navCon {
      &.wrapper_1200 {
        width: 1240px;
        overflow: unset !important;
        background-color: #fff;
      }
      // height: 100%;
      .moreCon {
        position: relative;
        .moreCategory {
          padding: 44px 44px 16px 44px;
          position: absolute;
          z-index: 9;
          top: 50px;
          right: 0;
          width: 1200px;
          background-color: #fff;
          box-shadow: 0 3px 16px rgba(0, 0, 0, 0.06);
          .item {
            margin: 0 40px 28px 0;
            &:hover {
              color: #0175c2;
            }
          }
        }
      }
      .list {
        height: 100%;
        // width: 1050px;
        overflow: hidden;
        padding: 20px;
        .item {
          height: 100%;
          line-height: 50px;
          overflow: hidden;
          & ~ .item {
            margin-left: 50px;
          }
          &:hover {
            color: #0175c2;
          }
          &.font-color {
            border-bottom: 2px solid #0175c2;
          }
        }
      }
      .more {
        position: relative;
        height: 100%;
        line-height: 50px;
        width: 132px;
        text-align: center;
        &:before {
          position: absolute;
          content: " ";
          left: 0;
          top: 50%;
          margin-top: -8px;
          width: 1px;
          height: 16px;
          background-color: #efefef;
        }
        &.font-color {
          border-bottom: 2px solid #0175c2;
        }
        .iconfont {
          margin-right: 6px;
        }
      }
    }
  }
  .title {
    color: #999999;
    height: 46px;
    line-height: 46px;
    .home {
      color: #282828;
    }
  }
  .wrapper {
    background-color: #fff;
    width: 1240px;
    padding: 25px 17px;
    cursor: pointer;
    .listCon {
      // width: 1100px;
      border-bottom: 1px dotted #efefef;
      padding-bottom: 10px;
      position: relative;
      .selected {
        width: 220px;
        max-height: 94px;
        border-radius: 4px;
        border: 1px solid #dddddd;
        padding: 5px 0 5px 10px;
        margin-right: 10px;
        background-color: #fff;
        .seleBrand {
          width: 175px;
          .itemBrand {
            color: #0175c2;
          }
        }
        .iconfont {
          padding: 3px 10px 0 10px;
          color: #999;
        }
      }
      .iconfont {
        font-size: 13px;
        color: #888;
        padding: 2px 0 6px 15px;
        &:hover {
          color: #0175c2;
        }
      }
      .more {
        color: #888;
        &:hover {
          color: #0175c2;
        }
      }
      .button {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .listD {
        width: 670px;
        /deep/.el-checkbox__label {
          font-weight: normal !important;
        }
        .itemD {
          margin-bottom: 20px;
        }
      }
    }
    .list {
      width: 670px;
      &.on {
        height: 29px;
        overflow: hidden;
      }
      .item {
        margin-right: 30px;
        margin-bottom: 10px;
        &:hover {
          color: #0175c2;
        }
      }
    }
    .name {
      color: #969696;
      margin-right: 20px;
      width: 75px;
      text-align: left;
    }
    .sort {
      margin-top: 20px;
      .item {
        margin-right: 30px;
        &:hover {
          color: #0175c2;
        }
        .icon {
          font-size: 15px;
          margin-left: 5px;
        }
        .iconfont {
          font-size: 15px;
          color: #e2e2e2;
          margin-left: 5px;
        }
      }
    }
  }
  .goods {
    width: 1220px;
    .item {
      background-color: #fff;
      padding: 16px;
      width: 224px;
      height: 340px;
      margin: 20px 20px 0 0;
      cursor: pointer;
      &:hover {
        box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
      }
      .pictrue {
        width: 192px;
        height: 192px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .money {
        margin-top: 12px;
        .font-color {
          font-weight: bold;
          font-size: 22px;
        }
        .y_money {
          font-size: 12px;
          color: #aaaaaa;
          text-decoration: line-through;
          margin-left: 8px;
        }
        .label {
          width: 20px;
          height: 20px;
          background: linear-gradient(
            330deg,
            rgba(231, 85, 67, 0.15) 0%,
            rgba(244, 103, 83, 0.15) 100%
          );
          font-size: 12px;
          text-align: center;
          line-height: 20px;
        }
      }
      .name {
        color: #5a5a5a;
        margin-top: 8px;
        height: 40px;
      }
      .bottom {
        font-size: 12px;
        color: #aaaaaa;
        margin-top: 10px;
      }
    }
  }
 
  /*去掉tabs底部的下划线*/
/deep/.el-tabs__header
>>>
.el-tabs__nav-wrap::after {
  position: static !important;
}
}
</style>



// WEBPACK FOOTER //
// GoodsList.vue?3c6fd8d0